import { CLASS_BOARD_DETAILS } from 'app/view/react_components/aside_panel/boardDetails/constants';
import * as React from 'react';
import './_Copy.scss'
import { ICopyProps } from './types';
import { COPY_BUTTON, COPY_LINK, COPY_TEXT, COPY_TEXT_LINK } from './constants';
import { Button } from 'kui';

export function Copy ({
    isDisallow,
    onClick,
}: ICopyProps) {
    const className = CLASS_BOARD_DETAILS + '-copy';

    return (
        <div className={className}>
            <div className={className + '__text'}>
                {COPY_TEXT}
                {' '}
                <a
                    href={COPY_LINK}
                    target="_blank"
                >
                    {COPY_TEXT_LINK}
                </a>
            </div>
            <Button
                className={className + '__button'}
                onClick={onClick}
                disabled={isDisallow}
            >
                {COPY_BUTTON}
            </Button>
        </div>
    );
}
